// Industry (giro) options for the lead compliance pre-screen.
//
// Prohibited / high-risk categories condensed from Compliance's
// "Giros y Actividades Prohibidas o de Alto Riesgo" policy (v2.0).
// The flag is informational — it marks the lead for manager/compliance
// attention; onboarding decisions always stay with Compliance, and the
// policy has an exception path for high-profile entities.
//
// UNIFIED SOURCE OF TRUTH: the same KB policy is projected into the
// compliance engine as `crosspoint-compliance/config/giros.v1.yaml` (via
// scripts/sync_kb.py, with provenance + version stamping). The engine
// RE-derives the flag from that config at ingest — these lists and
// deriveIndustryFlag() are a UX hint only, never the compliance truth.
// In production this list should come from the backend (served off the same
// versioned config) so Compliance can update policy without a frontend
// release; the engine's ingest keeps a mirror of these condensed labels
// (`ingest/leads.py` CRM_LABEL_FLAGS) until then — keep the two in sync.

// Common legitimate giros (the typical Crosspoint user base).
export const STANDARD_INDUSTRIES = [
  "Manufacturing",
  "Import/Export",
  "Agroindustry",
  "Technology / Software",
  "Professional services",
  "Logistics / Freight",
  "Retail / Consumer goods",
  "Construction",
  "Food & Beverage (non-alcohol)",
  "Automotive parts",
];

// Condensed from policy §1 (giros prohibidos — no se onboardean).
export const PROHIBITED_INDUSTRIES = [
  "Gambling / Betting / Casinos",
  "Weapons & explosives",
  "Cannabis / Tobacco / Vaping",
  "Pharma / Medical devices (ecommerce)",
  "Telecommunications (paid TV/radio/streaming)",
  "Alcohol",
  "Art / Antiques / Auction houses",
  "Non-profit organizations",
  "Political / Religious organizations",
  "Social media content / Influencers",
  "Narcotics-related",
  "IP rights / Copyright registries",
  "Massage / Tattoo services",
  "Casas de cambio / Money exchange",
  "Mining",
  "Pawn shops / Bail bonds / Collections",
  "Adult content / Dating services",
  "Multi-level marketing (MLM)",
];

// Condensed from policy §2 (giros de alto riesgo — evaluación reforzada).
export const HIGH_RISK_INDUSTRIES = [
  "Hydrocarbons",
  "Real estate development",
  "Leasing (arrendamiento)",
  "Textiles",
  "Jewelry / precious metals & stones",
  "Vehicle distribution (land/sea/air)",
  "Credit / Prepaid cards / E-wallets",
  "Non-bank lending",
  "Armoring services",
  "Cash-in-transit / Custody of valuables",
  "Cash-intensive businesses",
];

export const ALL_INDUSTRIES = [
  ...STANDARD_INDUSTRIES,
  ...HIGH_RISK_INDUSTRIES,
  ...PROHIBITED_INDUSTRIES,
];
